import React, { Component, PropTypes } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Row, Col, Alert, Button } from 'antd';
import classes from '../styles/ScheduleInfo.module.scss';
import { formatNumber } from 'utils/formatting';
import { dateTh, formatDate } from 'utils/formatDate';
import _ from 'lodash';

const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const formatTime = (timeNumber) => {
  return moment(`${timeNumber}`, 'Hmm').format('HH:mm');
};
const formatPrice = (number) => {
  return formatNumber(number, '0,0.00');
};

const ScheduleRevenue = ({ revenue }) => {
  let totalPrice = revenue.classRevenue;
  let totalPriceIncludeDiscount = revenue.classRevenue;

  return (
    <div className={cn('', classes.revenueContainer)}>
      <Row gutter={12}>
        <Col xs={12}>
          <div className="content">
            <table>
              <thead>
                <tr className="bold">
                  <td>Description</td>
                  <td className="text-right">Price</td>
                  <td>Qty.</td>
                  <td className="text-right">Total</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>ค่าสอน</td>
                  <td className="text-right">{formatPrice(revenue.classRevenue / revenue.seats)}</td>
                  <td>{revenue.seats}</td>
                  <td className="text-right">{formatPrice(revenue.classRevenue)}</td>
                </tr>
                {revenue.additionalList.length > 0 && (
                  <tr>
                    <td className="bold underline">Other Options</td>
                    <td />
                    <td />
                    <td />
                  </tr>
                )}
                {revenue.additionalList.map((additionalItem) => {
                  totalPrice += additionalItem.amount;
                  totalPriceIncludeDiscount += additionalItem.amount;
                  return (
                    <tr>
                      <td>{additionalItem.type}</td>
                      <td className="text-right">{formatPrice(additionalItem.amount / additionalItem.count)}</td>
                      <td>{additionalItem.count}</td>
                      <td className="text-right">{formatPrice(additionalItem.amount)}</td>
                    </tr>
                  );
                })}
                <tr className="bold-border-top">
                  <td className={'bold'}>Total</td>
                  <td />
                  <td />
                  <td className="text-right">{formatPrice(totalPrice)}</td>
                </tr>
                {revenue.discountList.length > 0 && (
                  <tr>
                    <td className="bold underline">Discount</td>
                    <td />
                    <td />
                    <td />
                  </tr>
                )}
                {revenue.discountList.map((discountItem) => {
                  totalPriceIncludeDiscount -= discountItem.amount;
                  let type = discountItem.type;
                  if (type === 'earlybird') {
                    type = 'Early Bird discount';
                  } else {
                    type = 'Special discount';
                  }
                  return (
                    <tr>
                      <td>{type}</td>
                      <td className="text-right">{type === 'earlybird' ? formatPrice(discountItem.amount / discountItem.count) : ''}</td>
                      <td>{type === 'earlybird' ? discountItem.count : ''}</td>
                      <td className="red text-right no-wrap">- {formatPrice(discountItem.amount)}</td>
                    </tr>
                  );
                })}
                <tr className="bold-border-top">
                  <td className={'bold'}>
                    Teacher
                    {"'"}s Revenue
                  </td>
                  <td />
                  <td />
                  <td className="text-right">{formatPrice(totalPriceIncludeDiscount)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
        <Col xs={12}>
          <div className="content">
            <table>
              <thead>
                <tr className="bold">
                  <td>Name</td>
                  <td>Price</td>
                  <td>Qty.</td>
                  <td className={'text-right'}>Total</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Net Com</td>
                  <td />
                  <td />
                  {revenue.serviceFee === 0 && <td className="text-right">{formatPrice(revenue.serviceFee)}</td>}
                  {revenue.serviceFee > 0 && <td className="red text-right">- {formatPrice(revenue.serviceFee)}</td>}
                </tr>
                <tr>
                  <td>Processing Fee</td>
                  <td />
                  <td />
                  {revenue.serviceFee === 0 && <td className="text-right">{formatPrice(revenue.cardFee)}</td>}
                  {revenue.serviceFee > 0 && <td className="red text-right">- {formatPrice(revenue.cardFee)}</td>}
                </tr>
                <tr className="bold-border-top">
                  <td className={'bold'}>Payout</td>
                  <td />
                  <td />
                  <td className="text-right">{formatPrice(revenue.teacherRevenue)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </div>
  );
};

// ScheduleRevenue.propTypes = {
//   schedule: PropTypes.any,
//   revenue: PropTypes.any,
//   classroom: PropTypes.any,
// };

export default ScheduleRevenue;
